import { TIER_CHIP_COLOR, TIER_LABEL } from "../lib/tiers";

export function TierBadge({ tier, score }: { tier: string; score?: number | null }) {
  return (
    <span
      className="badge"
      style={{ background: TIER_CHIP_COLOR[tier] ?? TIER_CHIP_COLOR.x }}
      title={TIER_LABEL[tier]}
    >
      {tier === "x" ? "—" : `T${tier}`}
      {score !== null && score !== undefined ? (
        <span className="num ml-1">{score.toFixed(0)}</span>
      ) : null}
    </span>
  );
}

export function Pill({
  children,
  tone = "muted",
}: {
  children: React.ReactNode;
  tone?: "muted" | "gold" | "ok" | "danger";
}) {
  const color =
    tone === "gold"
      ? "var(--gold)"
      : tone === "ok"
        ? "var(--ok)"
        : tone === "danger"
          ? "var(--danger)"
          : "var(--muted)";
  return (
    <span
      className="inline-block rounded border px-1.5 text-[11px] leading-[18px]"
      style={{ borderColor: color, color }}
    >
      {children}
    </span>
  );
}
